const initialValues = (
  template,
  tinkerlust,
  whatsapp
) => ({
  id             : template?.id || '',
  name           : template?.name || '',
  description    : template?.description || '',
  has_push_notif : template?.has_push_notification || false,
  tinkerlust     : {
    title      : tinkerlust?.title || '',
    body       : tinkerlust?.message || '',
    direct_url : tinkerlust?.on_click_url?.url || 'https://tinkerlust.com/'
  },

  whatsapp: {
    name      : whatsapp?.name || '',
    provider  : whatsapp?.provider || '',
    namespace : whatsapp?.namespace || '',
    has_image : whatsapp?.has_image || false,
    header    : whatsapp?.message_header ||'',
    body      : whatsapp?.message_body || '',
    buttons   : whatsapp?.message_buttons || [ {
      text        : '',
      event_value : '',
      event_type  : ''
    } ]
  }
})
export default initialValues
